import CustomizedButton from "@components/ButtonConfirm/ButtonConfirm";
import CreateCreditNoteForm from "@components/CreateCreditNoteForm/CreateCreditNoteForm";
import CreateNewInvoice from "@components/createInvoice";
import React from "react";
import Modal from "react-modal";
import "./index.scss";

const UpdateModal = ({
  modalInvoice,
  handleCloseModal,
  handleModalSave,
  title,
  isCreditNote,
  modalFields,
  isOpen,
}) => {
  console.log("🚀 ~ modalField22222222222s:", modalFields);

  return (
    <Modal
      isOpen={isOpen ? isOpen : !!modalInvoice}
      onRequestClose={handleCloseModal}
      contentLabel={title || "Modifier la facture"}
      className={`invoice-modal ${isCreditNote ? "credit-note" : ""}`}>
      {isCreditNote ? (
        <CreateCreditNoteForm
          companyId={modalFields?.companyId?._id}
          crediNoteData={modalFields}
        />
      ) : (
        <CreateNewInvoice
          isUpdate={true}
          handleCloseModal={handleCloseModal}
          title={title || "Modifier la facture"}
          invoiceData={modalInvoice}
          onSave={handleModalSave}
        />
      )}
      <div
        style={{ width: "100%" }}
        className="d-flex justify-content-end mt-4">
        <div style={{ width: "10%" }}>
          <CustomizedButton
            finalizeText={"Annuler"}
            bgColor={"#CACACA"}
            handleCreate={handleCloseModal}
          />
        </div>
      </div>
    </Modal>
  );
};

export default UpdateModal;
